<script>
	import appConfig from "@/app.config";

	import { notificationMethods } from "@/state/helpers";

	import { initializeApp } from "firebase/app";
	import { getMessaging, getToken, onMessage } from "firebase/messaging";
	import { Helper } from "./mixin/helper";

	import { REGISTER_FCM_TOKEN } from "@/services/api/fcm";

	export default {
		name: "app",
		page: {
			// All subcomponent titles will be injected into this template.
			titleTemplate(title) {
				title = typeof title === "function" ? title(this.$store) : title;
				return title ? `${title} | ${appConfig.title}` : appConfig.title;
			},
		},
		mixins: [Helper],
		data() {
			return {
				scTimer: 0,
				scY: 0,
			};
		},

		async mounted() {
			window.addEventListener("scroll", this.handleScroll);

			if (!localStorage.getItem("notification-popup")) {
				localStorage.setItem("notification-popup", JSON.stringify(this.$store.state.notification.config));
			}else {
				this.$store.commit("notification/configPopUp", JSON.parse(localStorage.getItem("notification-popup")));
			}

			if (window.location.host.startsWith("www")) {
				navigator.serviceWorker.getRegistrations()?.then(function (registrations) {
					for (let registration of registrations) {
						registration.unregister()
					}
					if (registrations.length == 0) {
						return
					}
					window.location.reload()
				})
			}

			if (localStorage.getItem("token") && localStorage.getItem("payload") && !localStorage.getItem("logout")) {
				const self = this;
				// Initialize the Firebase app in the service worker by passing in
				// your app's Firebase config object.
				// https://firebase.google.com/docs/web/setup#config-object
				const firebaseApp = initializeApp(
					{
						apiKey: process.env.VUE_APP_NOTIF_FIREBASE_API_KEY,
						authDomain: process.env.VUE_APP_NOTIF_FIREBASE_AUTH_DOMAIN,
						projectId: process.env.VUE_APP_NOTIF_FIREBASE_PROJECT_ID,
						storageBucket: process.env.VUE_APP_NOTIF_FIREBASE_STORAGE_BUCKET,
						messagingSenderId: process.env.VUE_APP_NOTIF_FIREBASE_MESSAGING_SENDER_ID,
						appId: process.env.VUE_APP_NOTIF_FIREBASE_APP_ID,
						measurementId: process.env.VUE_APP_NOTIF_FIREBASE_MEASUREMENT_ID,
					},
					"vsmsNotif"
				);

				// Retrieve an instance of Firebase Messaging so that it can handle background
				// messages.
				const messaging = getMessaging(firebaseApp);

				await Notification.requestPermission().then(function (permission) {
					if (permission === "granted") {
						getToken(messaging, {
							vapidKey:
								"BJWUpIU_lc4VbNHBSS7Hg4KDGcZxWiaHdFQIy0t3XOYRTRsqpXTb6DR6yooVhvNPScRFPVzoX28CxQV89cvFtRM",
						})
							.then((currentToken) => {
								if (currentToken) {
									self.$apollo
										.mutate({
											mutation: REGISTER_FCM_TOKEN,
											variables: {
												input: {
													registrationToken: currentToken,
												},
											},
										})
										.then(() => {
											localStorage.setItem('fcm', currentToken)
										});
									// Send the token to your server and update the UI if necessary
								} else {
									// Show permission request UI
									console.log(
										"No registration token available. Request permission to generate one."
									);
									// ...
								}
							})
							.catch((err) => {
								console.log("An error occurred while retrieving token. ", err);
								// ...
							});

						setTimeout(() => {
							onMessage(messaging, (payload) => {
								self.$toast.warning(
									`${payload.notification.title}, ${payload.notification.body}`,
									{
										position: "bottom-right",
										timeout:
											self.$store.state.notification.config.time.key * 1000,
										closeOnClick: true,
										pauseOnFocusLoss: true,
										pauseOnHover: true,
										draggable: false,
										draggablePercent: 0.6,
										showCloseButtonOnHover: false,
										hideProgressBar: true,
										closeButton: "button",
										icon: true,
										rtl: false,
									}
								);
							});
						}, 100);
					}
				});
			} else {
				localStorage.removeItem("logout")
				navigator.serviceWorker.getRegistrations()?.then(function (registrations) {
						for (let registration of registrations) {
							const sw = registration.active.scriptURL.split('/')
							if (sw.includes('firebase-messaging-sw.js')) {
								registration.unregister();
							}
						}
					});
			}

			const newFaviconPath = require(`@/assets/images/main-favicon.png`);
			const newFavicon = document.createElement('link');
			newFavicon.rel = 'icon';
			newFavicon.href = newFaviconPath;
			const head = document.head;
			const existingFavicons = head.querySelectorAll('link[rel="icon"]');
			existingFavicons.forEach((existingFavicon) => {
				head.removeChild(existingFavicon);
			});
			head.appendChild(newFavicon);
		},
		watch: {
			/**
			 * Clear the alert message on route change
			 */
			// eslint-disable-next-line no-unused-vars
			$route(to, from) {
				// clear alert on location change
				this.clearNotification();
			},
		},
		methods: {
			clearNotification: notificationMethods.clear,

			handleScroll: function () {
				if (this.scTimer) return;
				this.scTimer = setTimeout(() => {
					this.scY = window.scrollY;
					clearTimeout(this.scTimer);
					this.scTimer = 0;
				}, 100);
			},
			toTop: function () {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			},
		},
	};
</script>

<template>
	<div id="app">
		<RouterView />
		<span id="pagetop" class="mc-totop" @click="toTop" v-show="scY > 300">
			<i class="mc-fa icon-outline_arrow-ios-up"></i>
		</span>
	</div>
</template>
